  import axios from 'axios'
  
  const state = {
    user: null,
    anonymous: false,
    connected: false
  }
  const getters = {
    isAuthenticated: state => !!state.user,
    isAnonymous: state => state.anonymous,
    stateUser: state => state.user,
    stateConnected: state => state.connected,
  }
  const mutations = {
    setUser (state, user) {
      state.user = user
    },
    setAnonymous (state, anonymous) {
      state.anonymous = anonymous
    },
    setConnected (state, connected) {
      state.connected = connected
    }
  }
  const actions = {
    verifyLogged() {
      return axios.get(`${process.env.VUE_APP_URL}/me`)
    },
    async anonymousLogin({commit, state}, id) {
      let response = await axios.post(`${process.env.VUE_APP_URL}/login`, { 
        anonymousGuid: id
      })
      return response
    }
  }
  export default {
    state,
    getters,
    mutations,
    actions
  }
  